import {findIndex} from "lodash";

export default {

    methods: {

        /**
         *
         * This is used to remove duplicate packages for the current configuration. This is used when we are adding an application to the current configuration and we want to make sure that we are not adding the same application twice.
         *
         * This is specially necessary when the application is dropped at that time we are already having a duplicate application, and we want to smartly remove only the added application from the duplication.
         *
         * @param packageId
         * @param appName
         * @param newIndex
         */
        removeDuplicatePackageForCurrentConfiguration(packageId, appName, newIndex = false) {

            let self = this

            let applications = self.configurations[self.currentSelectedConfigurationIndex].value.applications;
            let firstOccurrenceIndex = findIndex(applications, (application, index) => (application.packageId === packageId))

            if (firstOccurrenceIndex > -1) {

                let secondOccurrenceIndex = findIndex(applications, (application, index) => (application.packageId === packageId), firstOccurrenceIndex + 1)

                if (secondOccurrenceIndex > -1 && isInteger(newIndex) && newIndex > -1) {
                    applications.splice(newIndex, 1)
                    self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('%{ appName } is already installed for the device %{ chosenModel }', { appName: appName, chosenModel: self.chosenModel })), 'info')
                }

            }

        }
    }
}
